"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vat_siren_siret_1 = require("@shinetools/vat-siren-siret");
const formatSIRENFromSIRET = (legalRegistrationNumber) => {
    const siren = (0, vat_siren_siret_1.toSIREN)(legalRegistrationNumber);
    if (siren) {
        return (0, vat_siren_siret_1.formatSIREN)(siren);
    }
    return legalRegistrationNumber;
};
exports.default = formatSIRENFromSIRET;
